export const PLAYER_STEP = 10;
